<div [class]="{'preview-mode': preview}">
  <div class="denialRationaleForm">
    <form [formGroup]="form">
      <div>
        <div class="field p-fluid">
          <label>Template:</label>
          <div class="p-field-value">
            <p-select
              placeholder="Select"
              formControlName="template"
              [options]="(denialRationaleTemplates$ | async) || []"
              name="templateId"
              appendTo="body"
              class="w-full"
              (onChange)="onSelectTemplate()"
              ariaLabelledBy="templateDescr"
              optionLabel="templateDescr"
            >
              <ng-template let-item pTemplate="selectedItem">
                <span>
                  {{ item.templateDescr }}
                  @if (item.edited) {
                    <span> - Edited</span>
                  }
                </span>
              </ng-template>
              <ng-template let-item pTemplate="item">
                <span [class]="{'font-semibold': item.edited}">
                  {{ item.templateDescr }}
                  @if (item.edited) {
                    <span> - Edited</span>
                  }
                </span>
              </ng-template>
            </p-select>
          </div>
        </div>
        @if (isDenialRationalePilotTemplate) {
          <div class="col mb-4">
            <div class="warning flex">
              <span class="pi pi-exclamation-triangle warning-icon"></span>
              <div class="ml-2">
                The rationale for a medical necessity denial will be added to the Member letter with the same wording
                you use in the
                Complete Denial Rationale box.
              </div>
            </div>
          </div>
        }
        @if (!isDenialRationalePilotTemplate) {
          <div class="field p-fluid">
            <label [class.field-required]="isLackOfPhysicianOrdersTemplate">Condition:</label>
            <div class="p-field-value">
              <textarea
                [rows]="2"
                pInputTextarea
                formControlName="condition"
                class="resize-y w-full"
                maxlength="500"
              ></textarea>
            </div>
          </div>
          @if (!isLackOfPhysicianOrdersTemplate) {
            <div class="field p-fluid">
              <label>Physician Clinical Rationale:</label>
              <div class="p-field-value">
                <textarea
                  [rows]="5"
                  pInputTextarea
                  formControlName="physicianClinicalRationale"
                  class="resize-y w-full"
                  maxlength="1250"
                ></textarea>
              </div>
            </div>
          }
          @if (model === null) {
            <div>
              Please input the Condition and Physician Clinical Rationale above. The complete Denial Rationale will be
              displayed below.
            </div>
          }
        }


        <ng-container *accessView="['ServiceLine.Write']">
          @if (edit) {
            <div class="flex gap-4 mb-4">
              <div class="grow">
                @if (isEditingTemplate) {
                  <span class="warning">
                    Please, do not try to remove or change highlighted text, it's required to save this form.
                  </span>
                }
              </div>
              @if (!isEditingTemplate && !isDenialRationalePilotTemplate) {
                <div class="shrink-0">
                  <button
                    pButton
                    type="button"
                    class="p-button-warning"
                    (click)="onEditTemplate()"
                    label="Edit"
                  ></button>
                </div>
              }
              @if (isEditingTemplate) {
                <div class="flex gap-2 shrink-0">
                  <button
                    pButton
                    label="Cancel"
                    type="button"
                    class="p-button-info"
                    (click)="onCancelEditedTemplate()"
                  ></button>
                  <button
                    pButton
                    label="Apply"
                    type="button"
                    class="p-button-warning"
                    (click)="onApplyEditedTemplate()"
                  ></button>
                </div>
              }
            </div>
          }
        </ng-container>
        <div class="field p-fluid">
          <label [class.field-required]="isDenialRationalePilotTemplate">Complete Denial Rationale:</label>
          <div class="p-field-value">
            @if (!isEditingTemplate) {
              <textarea
                [class.ng-invalid]="(form.get('completeRationale').touched && form.controls['completeRationale'].invalid)"
                [rows]="6"
                pInputTextarea
                [class.readonly]="isDenialRationalePilotTemplate ? false : (preview || !isEditingTemplate)"
                formControlName="completeRationale"
                class="resize-y w-full"
                [readonly]="isDenialRationalePilotTemplate ? false : (preview || !isEditingTemplate)"
              ></textarea>
              @if (form.controls['completeRationale'].hasError('maxlength')) {
                <small class="p-error">
                  Must be up to 3000 characters long.
                </small>
              }
            }

            @if (isEditingTemplate) {
              <div
                #contenteditable
                tabindex="0"
                class="resize-y readonly-fieldarea readonly-field p-component textarea-contenteditable template-editor"
                contentType="denial"
                contenteditable
                formControlName="templateLanguage"
              ></div>
            }
          </div>
        </div>
        <div class="field p-fluid">
          <label [class.field-required]="isDenialRationalePilotTemplate || isLackOfPhysicianOrdersTemplate">Physician
            Notes:</label>
          <textarea
            [class.ng-invalid]="(form.get('physicianNote').touched && form.controls['physicianNote'].invalid)"
            [rows]="4"
            pInputTextarea
            formControlName="physicianNote"
            class="resize-y w-full"
          ></textarea>
          @if (form.controls['physicianNote'].hasError('maxlength')) {
            <small class="p-error">
              Must be up to 3000 characters long.
            </small>
          }
        </div>
        <div class="py-2">
          By saving, I am attesting I have reviewed the denial rationale and certify this information is correct.
        </div>
      </div>
    </form>
  </div>
  <div class="grid grid-cols-12 gap-4 mt-6">
    @if (form.value.createdOn) {
      <div class="col-span-6">
        <div class="field flex mb-0">
          <label>Created On:</label>
          <div class="p-field-value ml-2">
            {{ form.value.createdOn | utcToLocal: 'MM/dd/yyyy hh:mm:ss a' }}
          </div>
        </div>
        <div class="field flex">
          <label>Created By:</label>
          <div class="p-field-value ml-2">
            {{ form.value.createdBy | userProfileCredentialsByEmail | async }}
          </div>
        </div>
      </div>
    }
    @if (isModifiedRationale()) {
      <div class="col-span-6">
        <div class="field flex mb-0">
          <label>Last Updated On:</label>
          <div class="p-field-value ml-2">
            {{ form.value.modifiedOn | utcToLocal: 'MM/dd/yyyy hh:mm:ss a' }}
          </div>
        </div>
        <div class="field flex">
          <label>Last Updated By:</label>
          <div class="p-field-value ml-2">
            {{ form.value.modifiedBy | userProfileCredentialsByEmail | async }}
          </div>
        </div>
      </div>
    }
  </div>

  @if (edit && !preview) {
    <div class="flex justify-end">
      <ng-container *accessView="['ServiceLine.Write']">
        <button
          type="button"
          pButton
          icon=""
          label="Cancel"
          class="p-button-info mr-4"
          (click)="onCancel()"
        ></button>
        <div class="vl mr-4"></div>
        <button
          type="button"
          pButton
          severity="secondary"
          label="Save & Route To PDS"
          class="p-button-sm mr-2"
          (click)="onSaveAndRouteToPDS()"
          [disabled]="isInvalidForm || isServiceLineFormInvalid"
        ></button>
        <button
          type="button"
          pButton
          label="Save"
          class="p-button-action"
          (click)="onSave()"
          [disabled]="isInvalidForm || isNotOriginalServiceLine"
        ></button>
      </ng-container>
    </div>
  }
</div>
